<template>
  <div class="is-flex is-justify-content-space-between is-align-items-center">
    <label class="label">Priority</label>
    <BaseDropdown
      :leftOffset="-10"
      wrapperClasses="column is-8 pr-0 pt-0"
      dialogClass="p-0"
      :onDialogChange="handleChange"
    >
      <template v-slot:toggle-button="{ handleToggle }">
        <div @click="handleToggle" class="pick-job-title-container">{{ value || 'Choose...' }}</div>
      </template>
      <div class="container py-3 px-2 max-width-dropdown">
        <label v-for="priority in priorities" :key="priority.id">
          <input type="radio" name="status" :value="priority.value" hidden />
          <p class="search_result has-text-right">{{ priority.value }}</p>
        </label>
      </div>
    </BaseDropdown>
  </div>
</template>

<script>
import BaseDropdown from '@/components/BaseDropdown'

export default {
  name: 'PositionPriority',
  components: {
    BaseDropdown
  },
  props: {
    value: {
      type: String
    },
    positionId: {
      type: Number
    }
  },
  data () {
    return {
      priorities: [
        { id: 1, value: 'High' },
        { id: 2, value: 'Medium' },
        { id: 3, value: 'Low' }
      ]
    }
  },
  methods: {
    async handleChange ({ target: { value: priority } }, closeModal) {
      try {
        await this.$network_utils.updatePosition({ position_id: this.positionId, priority: priority })
        this.$emit('input', priority)
        closeModal()
        this.$utils.emit('show_toast', { text: 'הצלחה' })
      } catch (e) {
        console.log(e)
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>

<style scoped>
  .max-width-dropdown {
    max-width: 500px;
    min-width: 250px;
    border: 2px solid rgba(0, 0, 0, 0.3);
    max-height: 400px;
    overflow-y: scroll;
  }
  .pick-job-title-container {
    cursor: pointer;
    background: url('/black_down_arrow.svg') no-repeat;
    background-position-y: center;
    background-position-x: 10px;
    background-size: 15px;
    width: 100%;
    display: inline-block;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    text-align: right;
  }
</style>
